import { Link, useLocation } from "react-router-dom";
import { useMemo, useState, useEffect } from "react";
import { MdDashboard } from "react-icons/md";
import { FaCarSide, FaGasPump, FaFileSignature } from "react-icons/fa";
import { FaUsers } from "react-icons/fa";
import { FiSettings, FiFileText } from "react-icons/fi";
import { MdOutlineCreditCard } from "react-icons/md";
import { MdOutlineNotificationsActive } from "react-icons/md";
import styles from "../style/MenuUserBar.module.css";
import { useRecoilValue } from "recoil";
import myInfoAtom from "../atoms/myInfoAtom";
import { app_version } from '../utils/config';
import logo from "../assets/logo.png";
// import formatNumberToUs from "../custom_functions/formatNumberToUs";

function Menu() {
  const location = useLocation();
  const [activeMenu, setActiveMenu] = useState("Dashboard");
  const myInfo = useRecoilValue(myInfoAtom);
  const menuStyle = "py-3 px-4 text-neutral-600 text-sm cursor-pointer flex gap-3 items-center mx-2 transition-all duration-200 rounded-lg hover:bg-neutral-100";
  const hoverStyle = "hover:text-primary hover:bg-primary-light";
  const loggedInAs = myInfo?.loggedInAs || (typeof window !== "undefined" ? window.localStorage.getItem("loggedInAs") : null);
  const isFleetManager = loggedInAs === "fleet_manager";

  useEffect(() => {
    const path = location.pathname;
    if (path === "/") setActiveMenu("Dashboard");
    else if (path === "/vehicles") setActiveMenu("Vehicles");
    else if (path === "/service_requests") setActiveMenu("Service Requests");
    else if (path === "/billing") setActiveMenu("Billing");
    else if (path === "/invoice") setActiveMenu("Invoice");
    else if (path === "/reminders") setActiveMenu("Reminders");
    else if (path === "/teams") setActiveMenu("Team");
  }, [location.pathname]);

  const handleMenuClick = (menuName) => {
    setActiveMenu(menuName);
  };

  return (
    <div
      className='h-screen overflow-y-auto bg-white border-r border-neutral-200 sticky top-0 flex flex-col justify-between shadow-sm'
    >
      <div>
        <div className="p-2 border-b border-neutral-200">
          <div className="flex items-center gap-3">
            <div className="flex items-center justify-center w-14 h-14 rounded-lg overflow-hidden">
              <img src={logo} alt="Logo" className="w-full h-full object-contain" />
            </div>
            <span className="font-bold text-lg text-neutral-900">Fleet Management</span>
          </div>
        </div>

        <nav className="py-4 px-2">
          <Link
            to={"/"}
            onClick={() => handleMenuClick("Dashboard")}
            className={`${menuStyle} ${hoverStyle} ${activeMenu === "Dashboard" && "text-primary bg-primary-light border-l-4 border-primary"}`}
          >
            <MdDashboard size={20} />
            <span>Dashboard</span>
          </Link>
          <Link
            to={"/vehicles"}
            onClick={() => handleMenuClick("Vehicles")}
            className={`${menuStyle} ${hoverStyle} ${activeMenu === "Vehicles" && "text-primary bg-primary-light border-l-4 border-primary"}`}
          >
            <FaCarSide size={18} />
            <span>Vehicles</span>
          </Link>
          <Link
            to={"/service_requests"}
            onClick={() => handleMenuClick("Service Requests")}
            className={`${menuStyle} ${hoverStyle} ${activeMenu === "Service Requests" && "text-primary bg-primary-light border-l-4 border-primary"}`}
          >
            <FaFileSignature size={18} />
            <span>Service Requests</span>
          </Link>
          <Link
            to={"/billing"}
            onClick={() => handleMenuClick("Billing")}
            className={`${menuStyle} ${hoverStyle} ${activeMenu === "Billing" && "text-primary bg-primary-light border-l-4 border-primary"}`}
          >
            <MdOutlineCreditCard size={20} />
            <span>Billing</span>
          </Link>
          <Link
            to={"/invoice"}
            onClick={() => handleMenuClick("Invoice")}
            className={`${menuStyle} ${hoverStyle} ${activeMenu === "Invoice" && "text-primary bg-primary-light border-l-4 border-primary"}`}
          >
            <FiFileText size={20} />
            <span>Invoice</span>
          </Link>
          <Link
            to={"/reminders"}
            onClick={() => handleMenuClick("Reminders")}
            className={`${menuStyle} ${hoverStyle} ${activeMenu === "Reminders" && "text-primary bg-primary-light border-l-4 border-primary"}`}
          >
            <MdOutlineNotificationsActive size={20} />
            <span>Reminders</span>
          </Link>
          {isFleetManager && (
            <Link
              to={"/teams"}
              onClick={() => handleMenuClick("Team")}
              className={`${menuStyle} ${hoverStyle} ${activeMenu === "Team" && "text-primary bg-primary-light border-l-4 border-primary"}`}
            >
              <FaUsers size={18} />
              <span>Admin</span>
            </Link>
          )}
        </nav>
      </div>
      {/* Bottom bar: Display app version */}
      <div className="flex flex-col items-center justify-center w-full py-4 px-4 border-t border-neutral-200 mt-auto">
        <p className="text-xs">© 2025 Arkilos Inc. All rights reserved.</p>
        <p className="text-xs text-neutral-400">Rev.{app_version}</p>
      </div>
    </div>
  );
}
export default Menu;
